import { render, staticRenderFns } from "./EditProductModal.vue?vue&type=template&id=1a9fd0fa"
import script from "./EditProductModal.vue?vue&type=script&lang=ts"
export * from "./EditProductModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports